import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_4aa5b228";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_4aa5b228" };
/** script content **/
require("./radio.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex4aa5b228%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fradio%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_4aa5b228"],
    ctorType: "component",
    outputPath: "components/index4aa5b228/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
